import type { SVGProps } from 'react';

const WarningSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M16 15H0V12L7 0H9L16 12V15ZM7 4H9V9H7V4ZM7 11H9V13H7V11Z" fill="#FFD100" />
  </svg>
);

export default WarningSvg;
